export function renderNavbar(): string {
  return `
    <nav class="navbar">
      <div class="nav-container">
        <a href="#" class="brand">
          <span class="brand-shield">🛡️</span>
          <span class="brand-name">TRIBUTE <span class="brand-highlight">DEFENSE</span></span>
        </a>
        <div class="nav-links">
          <a href="#mission">Mission</a>
          <a href="#capabilities">Capabilities</a>
          <a href="#contact" class="btn-primary-sm">Get in Touch</a>
        </div>
      </div>
    </nav>
  `;
}

